export default (theme) => ({
  couchIcon: {
    width: 314,
    maxHeight: 140,
    height: 'auto',
    [theme.breakpoints.down('xl')]: {
      width: 240,
    },
    [theme.breakpoints.down('md')]: {
      width: 196,
    },
  },
  couchIconPath: {
    fill: theme.palette.primary.main,
  },
});
